import { MainContainerWrapper } from "./styledComponents";
import {BaseCourses} from "../../../BaseCourses";

const MainContainer = () => {
    return <MainContainerWrapper><BaseCourses/></MainContainerWrapper>
};

export default MainContainer;
